import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'

import './syncfusion';
import Clarity from '@microsoft/clarity'
import { env } from './api/constants'

const clarityId = env.clarityId ?? ''
if(clarityId)
  Clarity.init(clarityId);

const ele = document.getElementById('root')
if (ele) {
  const root = ReactDOM.createRoot(ele)
  root.render(
    <App />
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
